export interface PartnerForm {
  name: string;
  email: string;
  password: string;
  sources: string[];
}

export const EMPTY_PARTNER_FORM: PartnerForm = {
  name: '',
  email: '',
  password: '',
  sources: [],
};
